import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-audits',
  templateUrl: './quality-audits.component.html',
  styleUrls: ['./quality-audits.component.scss']
})
export class QualityAuditsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
